import React from 'react';
import { Box } from '@mui/material';
import { LanguagesAndPreferences } from '../../types/types';
import { LanguagePreferencesForm } from './LanguagePreferencesForm';

interface UserPreferencesFormProps {
  languagesAndPreferences?: LanguagesAndPreferences;
  onSuccessfulFormSubmission: () => void;
}

const UserPreferencesForm = ({
  languagesAndPreferences,
  onSuccessfulFormSubmission,
}: UserPreferencesFormProps) => {
  return (
    <Box sx={{ p: 4 }}>
      <LanguagePreferencesForm
        submitButtonText="Update Preferences"
        useRoundedButton={false}
        languagesAndPreferences={languagesAndPreferences}
        onSuccessfulFormSubmission={onSuccessfulFormSubmission}
      />
    </Box>
  );
};

export default UserPreferencesForm;
